import React from 'react';

function GridChoice(props) {
    return (
        <div></div>
    );
}

export default GridChoice;